import { PersonFormState } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { personSchema } from '../../personsBasic/resources/schema';
import { messages } from './messages';

export { personSchema };

const peopleSchema = z
    .object({
        persons: z.array(personSchema),
    })
    .superRefine((values, ctx) => {
        if (
            !values.persons
                .filter((person) => person.verifyNeeded)
                .every((person) => person.personFormState === PersonFormState.InvitationSent)
        ) {
            ctx.addIssue({
                path: ['persons'],
                message: messages.notAllPersonsFilled,
                code: z.ZodIssueCode.custom,
            });
        }
    });

export const schema = z
    .object({
        people: peopleSchema,
    })
    .passthrough();
